import type { CalculatorPageState } from "web_myplann/Calculators/Types/CalculatorPageState";
import type { CalculatorPrefill } from "web_myplann/Utils/WebViewModel";
import { z } from "zod";

const calculatorPageStateSchema = z.object({
	prefill: z
		.object({
			propertyPrice: z.number().optional(),
			originMonthlyPayment: z.number().optional(),
			originInterest: z.number().optional(),
			originMortgageYears: z.number().optional(),
			repaymentPeriod: z.number().optional(),
			contractId: z.number().optional(),
			contractNumber: z.string().optional(),
			producer: z.string().optional(),
		})
		.nullish(),
}) satisfies z.ZodType<CalculatorPageState>;

export const getCalculatorPrefill = (
	state: unknown,
): CalculatorPrefill | undefined =>
	calculatorPageStateSchema.safeParse(state).data?.prefill ?? undefined;
